import { useHistory } from 'lib/router'
import { useStore } from 'state/store'
import { Home } from 'views/Home'

const PMHomeContainer = () => {
  const workspaceId = useStore(state => state.workspace.id)
  const history = useHistory()

  return (
    <Home
      step1={{
        title: 'pmportal.home.pm.step1.title',
        text: 'pmportal.home.pm.step1.text',
        linkLabel: 'pmportal.home.pm.step1.button',
        linkName: `/workspaces/${workspaceId}/tenants`,
      }}
      step2={{
        title: 'pmportal.home.pm.step2.title',
        text: 'pmportal.home.pm.step2.text',
        linkLabel: 'pmportal.home.pm.step2.button',
        linkName: `/workspaces/${workspaceId}/settings/billing`,
      }}
      step3={{
        title: 'pmportal.home.pm.step3.title',
        text: 'pmportal.home.pm.step3.text',
        linkLabel: 'pmportal.home.pm.step3.button',
        linkName: `/workspaces/${workspaceId}/incentives`,
      }}
      onLinkClick={linkName => {
        history.push(linkName)
      }}
    />
  )
}

export default PMHomeContainer
